module.exports = __webpack_public_path__ + "img/data_box_area1.446e98b1.png";